import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  //Pagination,
  Stack,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";

import SwapVertIcon from "@mui/icons-material/SwapVert";

const DashBoardTable = ({
  columns,
  rows,
  sortConfig,
  onSort,
  page,
  totalPages,
  onPageChange,
  rowsPerPage,
  onRowsPerPageChange,
  totalResults,
  showFooter = true,
}) => {
  return (
    <>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: "1px solid #eee",
          borderRadius: "4px",
        }}
      >
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow sx={{ bgcolor: "#0F1E3D" }}>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  onClick={() => column.sortable && onSort(column.id)}
                  sx={{
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: "12px",
                    textTransform: "uppercase",
                    borderBottom: "none",
                    cursor: column.sortable ? "pointer" : "default",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    {column.label}

                    {column.sortable && (
                      <SwapVertIcon
                        sx={{
                          fontSize: "16px",
                          opacity: sortConfig.key === column.id ? 1 : 0.6,
                        }}
                      />
                    )}
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:nth-of-type(even)": {
                      bgcolor: "#F9F9F9",
                    },
                    "& td": {
                      py: 1.5,
                      fontSize: "13px",
                    },
                  }}
                >
                  {columns.map((column) => (
                    <TableCell key={column.id}>
                      {row[column.id] || "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  sx={{ py: 4 }}
                >
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Footer */}
      {showFooter && (
        <Stack
          direction={{
            xs: "column",
            sm: "row",
          }}
          spacing={2}
          sx={{
            mt: 3,
            display: "flex",
            alignContent: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="body2">
            Showing <b>{totalResults}</b> results
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <Typography variant="body2">Show:</Typography>

            <Select
              size="small"
              value={rowsPerPage}
              onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
              sx={{
                height: "32px",
                fontSize: "13px",
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
          </Box>
        </Stack>
      )}
    </>
  );
};

export default DashBoardTable;
